import { IfStmt, ThrowStmt } from '@angular/compiler';
import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import Swal from 'sweetalert2';
import { Memberprofile } from '../models/memberprofile.model';
import { CrudService } from '../service/crud.service';
import { ProfileService } from '../service/profile.service';
import { SharedService } from '../service/shared.service';
import { MemberProfileMail } from '../models/member-profile-mail.model';

import * as $ from 'jquery';


@Component({
  selector: 'app-memberjoininglist',
  templateUrl: './memberjoininglist.component.html',
  styleUrls: ['./memberjoininglist.component.css']
})
export class MemberjoininglistComponent implements OnInit {

  ProfileList: Memberprofile[] = [];
  TempProfileList: any[] = [];
  ProfileModel: Memberprofile = new Memberprofile();
  _ProfileModel: Memberprofile = new Memberprofile();
  _ProfileList: Memberprofile[] = [];
  CheckCount = 0;
  UserId: any = sessionStorage.getItem("userId");
  url: any = null;
  readonly defaultProfileImage = 'assets/images/profile-default.svg';
  msg = "";
  filesToUpload: any[] = [];
  FileUpload: any = [];
  files: any[] = [];
  _WelcomeEmail: any[] = [];
  isLoading: boolean = false;

  // Profile image crop (same flow as member profile)
  showCropModal = false;
  cropImageSrc: string | null = null;
  cropZoom = 1;
  cropOffsetX = 0;
  cropOffsetY = 0;
  isCropDragging = false;
  pendingFileName = '';
  private cropDragStartX = 0;
  private cropDragStartY = 0;
  private cropOffsetStartX = 0;
  private cropOffsetStartY = 0;
  private cropImage: HTMLImageElement | null = null;
  private readonly cropViewportSize = 280;
  private readonly cropOutputSize = 400;
  private profileImageRequestTmc: string = '';

  @ViewChild('cropCanvas', { static: false }) cropCanvas: ElementRef<HTMLCanvasElement>;
  @ViewChild('previewCanvas', { static: false }) previewCanvas: ElementRef<HTMLCanvasElement>;

  ProfileMailList: MemberProfileMail[] = [];

  ProfileMailModel: MemberProfileMail = new MemberProfileMail();
  _ProfileMailModel: MemberProfileMail = new MemberProfileMail();
  _ProfileMailList: MemberProfileMail[] = [];

  DisableSubmitButton: boolean = false;

  // Welcome mail recipients (editable) + workflow remarks
  mailTo: string = '';
  mailCc: string = '';
  mailBcc: string = '';
  mailOther: string = '';
  welcomeRemarks: string = '';
  hasHRProfile: boolean = false;
  hasBUHR: boolean = false;

  RecordID: string = '';
  pronounsSubject: string = '';
  pronounsPossessive: string = '';
  pronounsSubjectCaps: string = '';
  pronounsPossessiveCaps: string = '';

  pronounsGender: string = '';

  sbuFullName: string = '';
  phoneNo: string = '';
  constructor(private _profileser: ProfileService, private route: ActivatedRoute, public _SharedSer: SharedService, private router: Router, private _crudSer: CrudService) {

    this.ProfileModel = new Memberprofile();
    this.ProfileModel.MEMBER_TMC = sessionStorage.getItem("userId");
  }

  ngOnInit() {
    this.loadRoleFlags();
    this.getAllDetails("0");
  }

  loadRoleFlags() {
    try {
      const roleFlags = sessionStorage.getItem('rolesFlags');
      if (roleFlags) {
        const flags = JSON.parse(roleFlags);
        this.hasHRProfile = !!flags.hasHRProfile;
        this.hasBUHR = !!flags.hasBUHR;
      }

      // Tara ISBUHR flag (set at login)
      const isBuhr = sessionStorage.getItem('ISBUHR');
      if (isBuhr === '1' || isBuhr === 'true') {
        this.hasBUHR = true;
      }

      // Fallback: UserRole list from login userdata
      const userdataRaw = sessionStorage.getItem('userdata');
      if (userdataRaw) {
        try {
          const userdata = JSON.parse(userdataRaw);
          const roles = (userdata && userdata.UserRole) || [];
          if (roles.some((r: any) => r && r.ACTIVE !== false &&
            (r.ACCESS_ROLE === 'HRPROFILE'))) {
            this.hasHRProfile = true;
          }
          if (roles.some((r: any) => r && r.ACTIVE !== false &&
            (r.ACCESS_ROLE === 'BUHR' || r.ACCESS_ROLE === 'BHR' || r.ACCESS_ROLE === 'BU HR'))) {
            this.hasBUHR = true;
          }
          if (userdata.ISBUHR === 1 || userdata.ISBUHR === '1' || userdata.ISBUHR === true) {
            this.hasBUHR = true;
            sessionStorage.setItem('ISBUHR', '1');
          }
        } catch { /* ignore parse */ }
      }
    } catch (e) {
      this.hasHRProfile = false;
      this.hasBUHR = false;
    }
  }

  SearchTMC: string = '';
  statusFilter: string = '0';
  Name: string;
  Status: string;
  Branch: string;
  SBU: string;

  p = 1;
  itemsPerPage = 25;
  paginationId = 'member-joining-list';

  SearchByTMCList(event: any) {
    const searchValue = (this.SearchTMC && this.SearchTMC.trim().toLowerCase()) || '';
    this.p = 1;
    const source = Array.isArray(this.TempProfileList) ? this.TempProfileList : [];

    if (searchValue !== '') {
      this.ProfileList = source.filter(x =>
        x.STATUS === this.Status &&
        ((x.MEMBER_TMC && x.MEMBER_TMC.toLowerCase().indexOf(searchValue) !== -1) ||
          (x.MEMBER_NAME && x.MEMBER_NAME.toLowerCase().indexOf(searchValue) !== -1) ||
          (x.MEMBER_SBU && x.MEMBER_SBU.toLowerCase().indexOf(searchValue) !== -1))
      );
    } else {
      this.ProfileList = source.filter(x => x.STATUS === this.Status);
    }
  }

  get totalRecords(): number {
    return this.ProfileList ? this.ProfileList.length : 0;
  }

  get pageStart(): number {
    if (this.totalRecords === 0) {
      return 0;
    }
    return (this.p - 1) * this.itemsPerPage + 1;
  }

  get pageEnd(): number {
    if (this.totalRecords === 0) {
      return 0;
    }
    return Math.min(this.p * this.itemsPerPage, this.totalRecords);
  }

  onPageChange(page: number) {
    this.p = page;
  }

  onPageSizeChange() {
    this.p = 1;
  }



  getAllDetails(FilterList: any) {
    this.isLoading = true;
    // Pass logged-in TMC so API can scope BHRPENDING to own-BU for BUHR users
    this._profileser.GetProfileDetails().subscribe(
      data => {
        const list = Array.isArray(data && data.Data) ? data.Data : [];
        this.TempProfileList = list;
        this.ProfileList = list;
        this.FilterApproverList(FilterList);
        this.isLoading = false;
      }, error => {
        this.TempProfileList = [];
        this.ProfileList = [];
        this.isLoading = false;
        console.error(error);
      });
  }

  FilterApproverList(item: any) {
    this.statusFilter = String(item);
    this.p = 1;
    this.SearchTMC = this.SearchTMC || '';
    const source = Array.isArray(this.TempProfileList) ? this.TempProfileList : [];

    if (item == "0") {
      this.Status = 'PENDING';
      this.ProfileList = source.filter(x => x.STATUS == "PENDING");
    }
    else if (item == "1") {
      this.Status = 'SUBMITTED';
      this.ProfileList = source.filter(x => x.STATUS == "SUBMITTED");
    }
    else if (item == "2") {
      this.Status = 'MAILSENT';
      this.ProfileList = source.filter(x => x.STATUS == "MAILSENT");
    }
    else if (item == "3") {
      this.Status = 'NOTIFY';
      this.ProfileList = source.filter(x => x.STATUS == "NOTIFY");
    }
    else if (item == "4") {
      this.Status = 'BHRPENDING';
      this.ProfileList = source.filter(x => x.STATUS == "BHRPENDING");
    }
    else if (item == "5") {
      this.Status = 'BHRAPPROVED';
      this.ProfileList = source.filter(x => x.STATUS == "BHRAPPROVED");
    }
  }

  setActiveTab(tab: string): void {
    // Pending BU HR = BUHR-only; Approved by BU HR = HR or BUHR
    if (tab === '4' && !this.hasBUHR) {
      return;
    }
    if (tab === '5' && !(this.hasHRProfile || this.hasBUHR)) {
      return;
    }
    if (this.statusFilter === tab) {
      return;
    }
    this.SearchTMC = '';
    this.p = 1;
    this.FilterApproverList(tab);
  }

  onStatusFilterChange(): void {
    this.setActiveTab(this.statusFilter);
  }

  getStatusLabel(): string {
    if (this.statusFilter === '0') {
      return 'Profile Pending for Welcome Note';
    }
    if (this.statusFilter === '1') {
      return 'Profile Submitted for Welcome Note';
    }
    if (this.statusFilter === '2') {
      return 'Welcome Note History';
    }
    if (this.statusFilter === '4') {
      return 'Pending BU HR Approval';
    }
    if (this.statusFilter === '5') {
      return 'Approved by BU HR';
    }
    return 'Profile Notification';
  }

  getEmptyColspan(): number {
    if (this.statusFilter === '0') {
      return 11;
    }
    if (this.statusFilter === '1' || this.statusFilter === '4' || this.statusFilter === '5') {
      return 12;
    }
    if (this.statusFilter === '2') {
      return 14;
    }
    return 12;
  }
  ViewProfile(recordID: string) {
    this.RecordID = recordID;
    this.url = null;
    this.files = [];
    this.FileUpload = [];
    this.pronounsSubject = '';
    this.pronounsPossessive = '';
    this.pronounsSubjectCaps = '';
    this.pronounsPossessiveCaps = '';
    this.pronounsGender = '';
    this._profileser.GetProfileDetailsByProfileId(recordID).subscribe(
      data => {
        if (data.Status) {
          let FullName = data.Data.MEMBER_SBU;
          if (FullName == 'AMC') {
            this.sbuFullName = 'Annual Maintenance Contract';
          } else if (FullName == 'BA') {
            this.sbuFullName = 'Business Application';
          } else if (FullName == 'CS') {
            this.sbuFullName = 'Cloud Solutions';
          } else if (FullName == 'TSS') {
            this.sbuFullName = 'Technology Staffing Solutions';
          } else if (FullName == 'IFS') {
            this.sbuFullName = 'Information Security';
          } else if (FullName == 'INS') {
            this.sbuFullName = 'Infrastructure Solutions';
          } else if (FullName == 'IS') {
            this.sbuFullName = 'Integrating Services';
          } else if (FullName == 'MPS') {
            this.sbuFullName = 'Managed Printing Services';
          } else if (FullName == 'MS') {
            this.sbuFullName = 'Managed Services';
          } else if (FullName == 'TDE') {
            this.sbuFullName = 'Team Digital Engineering';
          } else if (FullName == 'Shared') {
            this.sbuFullName = 'Integrating Services'
          } else if (FullName == 'ES') {
            this.sbuFullName = 'Enterprise Solutions'
          }
          this._ProfileModel = data.Data;
          console.log('data.Data', this._ProfileModel);
          this._WelcomeEmail = data.Data.WelcomeEmails;
          this.initWelcomeMailRecipients(data.Data);
          // BUHR actions use isBuhrForCurrentRequest(); do not promote hasBUHR from HR/assigned here
          // (Pending BU HR tab must stay ISBUHR / BUHR-role only).
          if (this._ProfileModel.MEMBER_GENDER === 'Male') {
            this.pronounsSubject = 'he';
            this.pronounsPossessive = 'him';
            this.pronounsPossessiveCaps = 'His';
            this.pronounsSubjectCaps = 'He';
            this.pronounsGender = 'him';
          } else if (this._ProfileModel.MEMBER_GENDER === 'Female') {
            this.pronounsSubject = 'she';
            this.pronounsPossessive = 'her';
            this.pronounsPossessiveCaps = 'Her';
            this.pronounsSubjectCaps = 'She';
            this.pronounsGender = 'her';
          }
          // Load photo for the selected member only (never the logged-in HR user)
          if (this._ProfileModel.MEMBER_TMC) {
            this.GetAllPIDocuments(this._ProfileModel.MEMBER_TMC);
          }
        }
      },
      error => { console.error(error); }
    );
  }

  ViewProfilePage(recordID: string) {
    this.router.navigate(['/memberNewjoinee'],
      { queryParams: { p: btoa(recordID) } });
  }

  GetAllPIDocuments(DocumentNo: string) {
    if (!DocumentNo) {
      this.url = null;
      this.files = [];
      return;
    }
    this.profileImageRequestTmc = DocumentNo;
    this.url = null;
    this._profileser.GetAllDocuments(DocumentNo).subscribe(
      data => {
        // Ignore stale responses (e.g. after opening another member or refreshing list)
        if (this.profileImageRequestTmc !== DocumentNo) {
          return;
        }
        if (data && data.indexOf('Could not find a part of the path') <= -1 && data.length > 0 && data[0]) {
          this.files = [];
          this.url = this._crudSer.profilesiteUrl + "PROFILEIMAGE/" + DocumentNo + "/" + data[0] + '?dt=' + new Date();
          data.forEach((element: any) => {
            this.files.push({ name: element, DownloadFlag: true });
          });
        }
        else {
          this.url = null;
        }
      }, error => {
        if (this.profileImageRequestTmc === DocumentNo) {
          this.url = null;
        }
        console.error(error);
      });
  }


  initWelcomeMailRecipients(profile: any) {
    const welcome = (profile && profile.WelcomeEmails && profile.WelcomeEmails[0]) ? profile.WelcomeEmails[0] : null;
    this.mailTo = (profile && profile.MAIL_TO) || (welcome && welcome.Email) || profile.MEMBER_EMAIL || '';
    this.mailCc = (profile && profile.MAIL_CC) || (welcome && welcome.Copy_Email) || '';
    this.mailBcc = (profile && profile.MAIL_BCC) || (welcome && welcome.BCC_Email) || '';
    this.mailOther = (profile && profile.OTHER_EMAIL) || (welcome && welcome.Other_Email) || '';
    this.welcomeRemarks = (profile && profile.HR_REMARKS) || '';
  }

  applyWelcomeMailFieldsToModel() {
    this._ProfileModel.MAIL_TO = this.mailTo;
    this._ProfileModel.MAIL_CC = this.mailCc;
    this._ProfileModel.MAIL_BCC = this.mailBcc;
    this._ProfileModel.OTHER_EMAIL = this.mailOther;
    this._ProfileModel.HR_REMARKS = this.welcomeRemarks;
    this._ProfileModel.PROFILE_ID = this.RecordID || this._ProfileModel.PROFILE_ID;
    this._ProfileModel.MODIFIED_BY = this.UserId;
  }

  validateWelcomeMailFields(requireRemarks: boolean): boolean {
    if (this._SharedSer.checkProperty(this.mailTo)) {
      this._SharedSer.SwalErrorMsg('Please enter To email');
      return false;
    }
    if (requireRemarks && this._SharedSer.checkProperty(this.welcomeRemarks)) {
      this._SharedSer.SwalErrorMsg('Please enter remarks');
      return false;
    }
    return true;
  }

  canEditWelcomeMail(): boolean {
    const status = this._ProfileModel.STATUS;
    // After BU HR approve: view + Send only (no edit / reject)
    return status === 'SUBMITTED' || status === 'BHRPENDING' || status === 'MAILSENT';
  }

  canAdminSendDirect(): boolean {
    return this.hasHRProfile && this._ProfileModel.STATUS === 'SUBMITTED';
  }

  canAdminSendToBHR(): boolean {
    return this.hasHRProfile && this._ProfileModel.STATUS === 'SUBMITTED';
  }

  /** True when logged-in user may act as BU HR on this request (strict: BUHR / ISBUHR / assigned TMC — not HRPROFILE). */
  isBuhrForCurrentRequest(): boolean {
    if (!this._ProfileModel) {
      return false;
    }
    if (this.hasBUHR) {
      return true;
    }
    const isBuhr = sessionStorage.getItem('ISBUHR');
    if (isBuhr === '1' || isBuhr === 'true') {
      return true;
    }
    const assigned = (this._ProfileModel.BUHR_ASSIGNED_TMC || '').toString().trim();
    const me = (this.UserId || sessionStorage.getItem('userId') || '').toString().trim();
    return !!(assigned && me && assigned === me);
  }

  /** @deprecated use specific canBUHR* helpers — kept for template compatibility */
  canBUHRAct(): boolean {
    return this.isBuhrForCurrentRequest() &&
      (this._ProfileModel.STATUS === 'BHRPENDING' || this._ProfileModel.STATUS === 'BHRAPPROVED');
  }

  canBUHRApprove(): boolean {
    return this.isBuhrForCurrentRequest() && this._ProfileModel.STATUS === 'BHRPENDING';
  }

  canBUHRReject(): boolean {
    return this.isBuhrForCurrentRequest() && this._ProfileModel.STATUS === 'BHRPENDING';
  }

  canBUHREdit(): boolean {
    return this.isBuhrForCurrentRequest() && this._ProfileModel.STATUS === 'BHRPENDING';
  }

  /** Send welcome mail only after Approve (BHRAPPROVED) — sole action on Approved tab */
  canBUHRSend(): boolean {
    return this.isBuhrForCurrentRequest() && this._ProfileModel.STATUS === 'BHRAPPROVED';
  }

  canResendWelcomeMail(): boolean {
    return this.hasHRProfile && this._ProfileModel.STATUS === 'MAILSENT';
  }

  /** Send welcome mail directly (no BU HR approval) — existing MAILSENT path */
  sendWelcomeMailDirect() {
    if (!this.validateWelcomeMailFields(false)) {
      return;
    }
    this.processWelcomeMailAction('MAILSENT', 'Welcome Email has been sent successfully!');
  }

  /** Admin sends to BU HR for approval */
  sendWelcomeMailToBUHR() {
    if (!this.validateWelcomeMailFields(false)) {
      return;
    }
    this.processWelcomeMailAction('BHRPENDING', 'Welcome Email sent to BU HR for approval.');
  }

  /** BU HR — Approve only (does not send welcome mail) */
  approveWelcomeMail() {
    if (!this.validateWelcomeMailFields(false)) {
      return;
    }
    this.processWelcomeMailAction('BHRAPPROVED', 'Approved by BU HR. You can now Send the Welcome Mail.');
  }

  /** BU HR — Edit / save recipients & remarks (keeps current status) */
  editWelcomeMailByBuhr() {
    if (!this.validateWelcomeMailFields(false)) {
      return;
    }
    const keepStatus = this._ProfileModel.STATUS === 'BHRAPPROVED' ? 'BHRAPPROVED' : 'BHRPENDING';
    this.processWelcomeMailAction(keepStatus, 'Changes saved successfully.');
  }

  /** BU HR — Send the Welcome Mail (after Approve) */
  sendWelcomeMailByBuhr() {
    if (!this.validateWelcomeMailFields(false)) {
      return;
    }
    this.processWelcomeMailAction('MAILSENT', 'Welcome Email has been sent successfully!');
  }

  /** BU HR reject with remarks */
  rejectWelcomeMail() {
    if (!this.validateWelcomeMailFields(true)) {
      return;
    }
    this.processWelcomeMailAction('BHRREJECTED', 'Welcome Email rejected. Returned to admin for rework.');
  }

  /** Resend after MAILSENT (discrepancies) */
  resendWelcomeMail() {
    if (!this.validateWelcomeMailFields(false)) {
      return;
    }
    this.processWelcomeMailAction('MAILSENT', 'Welcome Email has been resent successfully!');
  }

  /** Close Bootstrap modal and restore page scroll (body.modal-open locks overflow). */
  private closeBootstrapModal(modalSelector: string): void {
    const $modal = $(modalSelector);
    try {
      if ($modal.length && typeof ($modal as any).modal === 'function') {
        ($modal as any).modal('hide');
      }
    } catch (e) {
      // fallback below
    }
    $modal.removeClass('show').css('display', 'none').attr('aria-hidden', 'true');
    $('.modal-backdrop').remove();
    $('body').removeClass('modal-open').css({ overflow: '', 'padding-right': '' });
  }

  processWelcomeMailAction(status: string, successMsg: string) {
    this.DisableSubmitButton = true;
    this.applyWelcomeMailFieldsToModel();
    this._ProfileModel.STATUS = status;

    this._profileser.UpdateStatus(this._ProfileModel).subscribe(
      data => {
        if (data.Status) {
          this._SharedSer.SwalSuccessMsg(successMsg);
          this.DisableSubmitButton = false;
          // Keep modal open after Approve / Edit so BU HR can Send next
          if (status === 'BHRAPPROVED' || (successMsg && successMsg.indexOf('Changes saved') >= 0)) {
            this._ProfileModel.STATUS = status;
            if (this.RecordID) {
              this.ViewProfile(this.RecordID);
            }
            this.getAllDetails(status === 'BHRAPPROVED' ? '5' : '4');
          } else {
            this.closeBootstrapModal('#preview-new-joinee');
            this.url = null;
            this.files = [];
            if (status === 'MAILSENT') {
              this.getAllDetails('2');
            } else if (status === 'BHRPENDING') {
              this.getAllDetails('4');
            } else {
              this.getAllDetails('1');
            }
          }
        } else {
          this._SharedSer.SwalErrorMsg(data.Message || 'Action failed');
          this.DisableSubmitButton = false;
        }
      },
      error => {
        console.error(error);
        this.DisableSubmitButton = false;
      }
    );
  }

  UpdateProfileData(Status: string) {

    this.DisableSubmitButton = true;

    // Mail-only actions: do not require profile image re-upload
    const isMailOnlyAction = Status === 'MAILSENT' || Status === 'BHRPENDING' || Status === 'BHRAPPROVED' || Status === 'BHRREJECTED';

    if (!isMailOnlyAction && (!this.url || this.url === '' || (Array.isArray(this.url) && this.url.length === 0)) && this.FileUpload.length <= 0) {
      this._SharedSer.SwalErrorMsg('Please upload Profile Image');
      this.DisableSubmitButton = false;
      return;
    }

    if (Status == 'SAVED') {
      if (this._SharedSer.checkProperty(this._ProfileModel.MEMBER_HOME)) {
        this._SharedSer.SwalErrorMsg('Please enter Hometown');
        this.DisableSubmitButton = false;
        return;
      }
      if (this._SharedSer.checkProperty(this._ProfileModel.Member_Hobbies)) {
        this._SharedSer.SwalErrorMsg('Please enter Interests and Hobbies');
        this.DisableSubmitButton = false;
        return;
      }
      if (this._ProfileModel.MEMBER_EXP_TYPE == 'Experience' && this._SharedSer.checkProperty(this._ProfileModel.MEMBER_INTEREST)) {
        this._SharedSer.SwalErrorMsg('Please enter Field of Experience / Area of Expertise');
        this.DisableSubmitButton = false;
        return;
      }
    }

    if (Status == 'NOTIFY') {
      this._ProfileModel.STATUS = Status;

      if (this._ProfileModel.STATUS == "NOTIFY") {
        if (this._SharedSer.checkProperty(this._ProfileModel.HR_REMARKS)) {
          this._SharedSer.SwalErrorMsg('Please enter HR Remarks');
          this.DisableSubmitButton = false;
          return;
        }
        this._ProfileModel.STATUS = "NOTIFY";
        this._ProfileModel.HR_REMARKS = this._ProfileModel.HR_REMARKS;
      }
    }

    else if (Status == 'MAILSENT' || Status == 'BHRPENDING' || Status == 'BHRAPPROVED' || Status == 'BHRREJECTED') {
      this.applyWelcomeMailFieldsToModel();
      this._ProfileModel.STATUS = Status;
    }

    this._ProfileModel.MODIFIED_BY = this.UserId;

    if (this.FileUpload && this.FileUpload.length > 0) {
      this._ProfileModel.ProfileFileName = this.FileUpload[0].name;
    }
    if (this.url && typeof this.url === 'string' && this.url.includes(',')) {
      this._ProfileModel.ProfileFileBase64 = this.url.split(',')[1];
    }

    // For mail workflow actions, only UpdateStatus (do not re-save full profile)
    if (isMailOnlyAction) {
      this._profileser.UpdateStatus(this._ProfileModel).subscribe(
        data => {
          if (data.Status) {
            if (Status == "MAILSENT") {
              this._SharedSer.SwalSuccessMsg('Welcome Email has been sent successfully!');
            }
            else if (Status == "BHRPENDING") {
              this._SharedSer.SwalSuccessMsg('Changes saved / sent to BU HR.');
            }
            else if (Status == "BHRAPPROVED") {
              this._SharedSer.SwalSuccessMsg('Approved by BU HR. You can now Send the Welcome Mail.');
            }
            else if (Status == "BHRREJECTED") {
              this._SharedSer.SwalSuccessMsg('Welcome Email rejected.');
            }
            this.DisableSubmitButton = false;
            this.getAllDetails(Status == 'MAILSENT' ? '2' : (Status == 'BHRAPPROVED' ? '5' : (Status == 'BHRPENDING' ? '4' : '1')));
          }
          else {
            this._SharedSer.SwalErrorMsg(data.Message || 'Action failed');
            this.DisableSubmitButton = false;
          }
        }, error => {
          console.error(error);
          this.DisableSubmitButton = false;
        });
      return;
    }

    let formdata = new FormData();
    formdata.append("MemberProfile", JSON.stringify(this._ProfileModel));
    for (var i = 0; i < this.FileUpload.length; i++) {
      formdata.append(this.FileUpload[i].name, this.FileUpload[i]);
    }

    this._profileser.SaveProfileDetails(formdata).subscribe(
      data => {
        if (data.Status) {
          // debugger;
          this._SharedSer.SwalSuccessMsg('Profile Data updated successfully!');
          this.closeBootstrapModal('#preview-profile');
          this.DisableSubmitButton = false;
        }
        else {

          this._SharedSer.SwalSuccessMsg(data.Message);
          this.DisableSubmitButton = false;
        }
      }, error => console.error());

    this._profileser.UpdateStatus(this._ProfileModel).subscribe(
      data => {
        if (data.Status) {
          if (Status == "MAILSENT") {
            this._SharedSer.SwalSuccessMsg('Welcome Email has been sent successfully!');
            this.DisableSubmitButton = false;
          }
          else if (Status == "NOTIFY") {
            this._SharedSer.SwalSuccessMsg('Notification has been sent successfully!');
            this.DisableSubmitButton = false;
          }

          this.getAllDetails("1");
        }
        else {

          this._SharedSer.SwalSuccessMsg(data.Message);
          this._ProfileModel.STATUS = "NOTIFY";
          this.DisableSubmitButton = false;
        }

      }, error => console.error());
  }

  confirmSendRequest(profileId: any) {
    const result = confirm("Are you sure you want to send this request?");
    if (result) {
      this.SentRequest(profileId);
    }
  }


  SentRequest(recordID: string) {
    this.RecordID = recordID;

    this.ViewProfile(this.RecordID);

    this._ProfileModel.STATUS = "PENDING"
    this.ProfileModel.PROFILE_ID = this.RecordID;

    this._profileser.UpdateStatus(this._ProfileModel).subscribe(
      data => {
        if (data.Status) {

          Swal.fire({
            toast: true,
            title: "Request has been sent",
            icon: 'success',
            position: 'top',
            width: 350,
            timer: 4000,
            showConfirmButton: false,
            timerProgressBar: true,

            didOpen: (toast) => {
              toast.addEventListener('mouseenter', Swal.stopTimer)
              toast.addEventListener('mouseleave', Swal.resumeTimer)
            }
          })
          this.getAllDetails("0");
        }
        else {

          Swal.fire({
            toast: true,
            title: data.Message,
            icon: 'error',
            position: 'top',
            width: 350,
            timer: 4000,
            showConfirmButton: false,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener('mouseenter', Swal.stopTimer)
              toast.addEventListener('mouseleave', Swal.resumeTimer)
            }
          })
        }
      }, error => console.error());
  }


  getProfileDetails(TMC: string) {

    this._profileser.GetProfileMailDetailsById(TMC).subscribe(
      data => {
        if (data.Status) {
          if (data.Data != null) {
            this._ProfileMailModel = data.Data;

          }
        }
      }, error => console.error());
  }


  uploadFile(event: any) {
    const input = event.target;
    if (!input.files || !input.files[0]) {
      this.msg = 'You must select an image';
      return;
    }

    const file = input.files[0];
    const mimeType = file.type;

    if (!mimeType || mimeType.match(/image\/*/) == null) {
      this.msg = 'Only images are supported';
      this._SharedSer.SwalErrorMsg('Only images are supported');
      return;
    }

    if (!this.validateFile(file.name)) {
      Swal.fire({
        toast: true,
        title: 'Invalid File Format',
        icon: 'error',
        position: 'top',
        width: 350,
        timer: 4000,
        showConfirmButton: false,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener('mouseenter', Swal.stopTimer);
          toast.addEventListener('mouseleave', Swal.resumeTimer);
        }
      });
      return;
    }

    this.pendingFileName = file.name;
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      this.msg = '';
      this.cropImageSrc = reader.result as string;
      this.cropZoom = 1;
      this.cropOffsetX = 0;
      this.cropOffsetY = 0;
      this.showCropModal = true;
      setTimeout(() => this.initCropEditor(), 0);
    };
  }

  initCropEditor() {
    if (!this.cropImageSrc) {
      return;
    }
    this.cropImage = new Image();
    this.cropImage.onload = () => this.redrawCropCanvases();
    this.cropImage.onerror = () => {
      this._SharedSer.SwalErrorMsg('Unable to load the selected image');
      this.cancelCrop();
    };
    this.cropImage.src = this.cropImageSrc;
  }

  onCropZoomChange() {
    this.redrawCropCanvases();
  }

  startCropDrag(event: MouseEvent | TouchEvent) {
    if (!this.showCropModal) {
      return;
    }
    event.preventDefault();
    const point = this.getPointerPosition(event);
    this.isCropDragging = true;
    this.cropDragStartX = point.x;
    this.cropDragStartY = point.y;
    this.cropOffsetStartX = this.cropOffsetX;
    this.cropOffsetStartY = this.cropOffsetY;
  }

  @HostListener('document:mousemove', ['$event'])
  onCropDragMove(event: MouseEvent) {
    if (!this.isCropDragging) {
      return;
    }
    this.cropOffsetX = this.cropOffsetStartX + (event.clientX - this.cropDragStartX);
    this.cropOffsetY = this.cropOffsetStartY + (event.clientY - this.cropDragStartY);
    this.redrawCropCanvases();
  }

  @HostListener('document:mouseup')
  onCropDragEnd() {
    this.isCropDragging = false;
  }

  @HostListener('document:touchmove', ['$event'])
  onCropTouchMove(event: TouchEvent) {
    if (!this.isCropDragging || !event.touches.length) {
      return;
    }
    event.preventDefault();
    const touch = event.touches[0];
    this.cropOffsetX = this.cropOffsetStartX + (touch.clientX - this.cropDragStartX);
    this.cropOffsetY = this.cropOffsetStartY + (touch.clientY - this.cropDragStartY);
    this.redrawCropCanvases();
  }

  @HostListener('document:touchend')
  onCropTouchEnd() {
    this.isCropDragging = false;
  }

  private getPointerPosition(event: MouseEvent | TouchEvent) {
    if (event instanceof TouchEvent) {
      const touch = event.touches[0] || event.changedTouches[0];
      return { x: touch.clientX, y: touch.clientY };
    }
    return { x: event.clientX, y: event.clientY };
  }

  private getCropScale(image: HTMLImageElement): number {
    const baseScale = Math.max(
      this.cropViewportSize / image.width,
      this.cropViewportSize / image.height
    );
    return baseScale * this.cropZoom;
  }

  private drawCroppedImage(
    ctx: CanvasRenderingContext2D,
    image: HTMLImageElement,
    size: number
  ) {
    const scale = this.getCropScale(image);
    const drawWidth = image.width * scale;
    const drawHeight = image.height * scale;
    const x = (size - drawWidth) / 2 + this.cropOffsetX;
    const y = (size - drawHeight) / 2 + this.cropOffsetY;

    ctx.clearRect(0, 0, size, size);
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, 0, size, size);
    ctx.drawImage(image, x, y, drawWidth, drawHeight);
  }

  redrawCropCanvases() {
    if (!this.cropImage || !this.cropCanvas || !this.previewCanvas) {
      return;
    }

    const mainCanvas = this.cropCanvas.nativeElement;
    const previewCanvas = this.previewCanvas.nativeElement;
    const mainCtx = mainCanvas.getContext('2d');
    const previewCtx = previewCanvas.getContext('2d');

    if (!mainCtx || !previewCtx) {
      return;
    }

    this.drawCroppedImage(mainCtx, this.cropImage, this.cropViewportSize);
    this.drawCroppedImage(previewCtx, this.cropImage, 140);
  }

  applyCrop() {
    if (!this.cropImage) {
      return;
    }

    const exportCanvas = document.createElement('canvas');
    exportCanvas.width = this.cropOutputSize;
    exportCanvas.height = this.cropOutputSize;
    const exportCtx = exportCanvas.getContext('2d');

    if (!exportCtx) {
      return;
    }

    const scale = this.getCropScale(this.cropImage);
    const drawWidth = this.cropImage.width * scale;
    const drawHeight = this.cropImage.height * scale;
    const ratio = this.cropOutputSize / this.cropViewportSize;
    const x = ((this.cropViewportSize - drawWidth) / 2 + this.cropOffsetX) * ratio;
    const y = ((this.cropViewportSize - drawHeight) / 2 + this.cropOffsetY) * ratio;

    exportCtx.fillStyle = '#ffffff';
    exportCtx.fillRect(0, 0, this.cropOutputSize, this.cropOutputSize);
    exportCtx.drawImage(
      this.cropImage,
      x,
      y,
      drawWidth * ratio,
      drawHeight * ratio
    );

    const dataUrl = exportCanvas.toDataURL('image/jpeg', 0.92);
    this.url = dataUrl;

    const blob = this.dataUrlToBlob(dataUrl);
    const fileName = this.getCroppedFileName(this.pendingFileName);
    const croppedFile = new File([blob], fileName, { type: 'image/jpeg' });

    this.FileUpload = [croppedFile];
    this.files = [{ name: fileName, DownloadFlag: false }];
    this.closeCropModal();
  }

  cancelCrop() {
    this.closeCropModal();
  }

  private closeCropModal() {
    this.showCropModal = false;
    this.isCropDragging = false;
    this.cropImageSrc = null;
    this.cropImage = null;
  }

  private getCroppedFileName(originalName: string): string {
    const base = originalName ? originalName.replace(/\.[^.]+$/, '') : 'profile';
    return base + '.jpg';
  }

  private dataUrlToBlob(dataUrl: string): Blob {
    const parts = dataUrl.split(',');
    const mimeMatch = parts[0].match(/:(.*?);/);
    const mime = mimeMatch ? mimeMatch[1] : 'image/jpeg';
    const binary = atob(parts[1]);
    const array = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i++) {
      array[i] = binary.charCodeAt(i);
    }
    return new Blob([array], { type: mime });
  }

  validateFile(name: String) {
    var ext = name.substring(name.lastIndexOf('.') + 1);
    //.xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf
    if (ext.toLowerCase() == 'png' || ext.toLowerCase() == 'jpg'
      || ext.toLowerCase() == 'jpeg'
      || ext.toLowerCase() == 'gif'
      || ext.toLowerCase() == 'bmp'
      || ext.toLowerCase() == 'image/*'


    ) {
      return true;
    }
    else {
      return false;
    }
  }

  hasProfileImage(): boolean {
    if (this.url === null || this.url === undefined) {
      return false;
    }
    if (Array.isArray(this.url) && this.url.length === 0) {
      return false;
    }
    return String(this.url).trim() !== '';
  }

  getProfileImageUrl(): string {
    return this.hasProfileImage() ? this.url : this.defaultProfileImage;
  }

  onProfileImageError(): void {
    this.url = null;
  }

  getAvatarInitials(): string {
    const name = this._ProfileModel.MEMBER_NAME || '';
    const parts = name.trim().split(/\s+/).filter(function (part) { return part.length > 0; });
    if (parts.length === 0) {
      return '';
    }
    if (parts.length === 1) {
      return parts[0].charAt(0).toUpperCase();
    }
    return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
  }
}
